
function Contact() {

    return (
        <div id='intro'>
        </div>
    )
}

export default Contact;